/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */
/**
 * @deprecated Use `import { extractTracingHeaders } from '@atlaskit/util-service-support/extractTracingHeaders'` instead.
 */
export { extractTracingHeaders } from './extractTracingHeaders';
/**
 * @deprecated Use `import { requestService } from '@atlaskit/util-service-support/requestService'` instead.
 */
export { requestService } from './requestService';
